/**
 * Primary 1 Math tuition information page.
 *
 * What: Landing page for Primary 1 Mathematics tuition using LevelPageLayout.
 * Why: Provides targeted information for parents searching for P1 Math support.
 * When: Update when P1 syllabus changes or messaging refinements are needed.
 */
import React, { useMemo } from 'react';

import LevelPageLayout from '@/components/levels/LevelPageLayout.js';
import SchoolDirectory from '@/components/schools/SchoolDirectory.js';
import { toLevelPageLayoutContent } from '@/content/levelPageLayoutAdapter';
import { buildPrimaryContent } from '@/content/levels/primaryContent';
import { useSchoolDirectory } from '@/hooks/useSchoolDirectory.js';

function Primary1Page() {
  const layoutContent = useMemo(
    () =>
      toLevelPageLayoutContent(buildPrimaryContent('primary1'), {
        levelLabel: 'Primary 1',
      }),
    []
  );
  const { schools, isLoading, hasLoadError } = useSchoolDirectory({
    schoolType: 'primary',
  });

  return (
    <LevelPageLayout content={layoutContent}>
      <SchoolDirectory
        schools={schools}
        heading="Primary Schools in Singapore"
        isLoading={isLoading}
        emptyStateMessage={
          hasLoadError
            ? 'Unable to load schools right now.'
            : 'No schools found for this zone.'
        }
      />
    </LevelPageLayout>
  );
}

export default Primary1Page;
